(function () {

    const accordionElms = document.querySelectorAll( '.accordion' );

    if ( ! accordionElms ) {
        return;
    }

    accordionElms.forEach( (elm) => {
        elm.addEventListener( 'click', ( e ) => {
            if ( ! e.target.classList.contains( 'accordion-item__trigger' ) ) {
                return;
            }

            e.preventDefault();

            const itemElm = e.target.closest( '.accordion-item' );
            const contentElm = itemElm.querySelector( '.accordion-item__content' );

            elm.querySelectorAll( '[open]' ).forEach( (openElm) => {
                if ( openElm === itemElm ) {
                    return false;
                }

                openElm.removeAttribute( 'open' );
                openElm.querySelector( '.accordion-item__content' ).setAttribute( 'aria-hidden', 'true' );
            });

            if ( itemElm ) {
                itemElm.toggleAttribute( 'open' );
                contentElm.setAttribute( 'aria-hidden', ! itemElm.hasAttribute( 'open' ) );
            }

            return false;
        });

    });

})();
